module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"modify":"Modify","delete":"Delete","deleteDiscussion":"Delete Discussion","comment":"Comment"},"fr":{"modify":"Modifier","delete":"Supprimer","deleteDiscussion":"Supprimer la discussion","comment":"commenter"},"de":{"modify":"Modifikator","delete":"LÖSCHEN","deleteDiscussion":"Chat löschen","comment":"Kommentator"}}')
  delete Component.options._Ctor
}
